module.exports = __webpack_public_path__ + "img/305.1ef9c623.png";